module.exports = __webpack_public_path__ + "img/zfxq.fec9aa71.png";